import styled from "styled-components";

import { Link } from "react-router-dom";

import React from "react";

function MenuList({ item, setSubMenuindex, subMenu }) {
  return <MainNavList to={`/${item.toLowerCase().replace(/\s/g, '')}`}>{item}</MainNavList>;
}

const MainNavList = styled(Link)`
  font-weight: 500;
  letter-spacing: 0.2px;
  color: white;
  font-size: 0.9rem;
  margin: 0rem 1rem;
  padding: 0.2rem 0.5rem;

  @media (max-width: 1300px) {
    margin: 0rem 0.5rem;
  }
  :hover,
  :active {
    background: #13324f;
    border-radius: 0.2rem;
  }

  @media (max-width: 1180px) {
    color: black;
    margin: 0.5rem 0rem;
    font-size: 1rem;
    font-weight: 600;

    :hover,
    :active {
      background: #dfdfdf;
      border-radius: 0.2rem;
    }
  }
`;

export default MenuList;
